var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendarIcon = function SvgCalendarIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.125 1.5H9V0.28125C9 0.12593 8.87407 0 8.71875 0H8.53125C8.37593 0 8.25 0.12593 8.25 0.28125V1.5H3.75V0.28125C3.75 0.12593 3.62407 0 3.46875 0H3.28125C3.12593 0 3 0.12593 3 0.28125V1.5H1.875C1.25367 1.5 0.75 2.00367 0.75 2.625V10.875C0.75 11.4963 1.25367 12 1.875 12H10.125C10.7463 12 11.25 11.4963 11.25 10.875V2.625C11.25 2.00367 10.7463 1.5 10.125 1.5ZM1.875 2.25H10.125C10.3318 2.25 10.5 2.41823 10.5 2.625V3.75H1.5V2.625C1.5 2.41823 1.66823 2.25 1.875 2.25ZM10.125 11.25H1.875C1.66823 11.25 1.5 11.0818 1.5 10.875V4.5H10.5V10.875C10.5 11.0818 10.3318 11.25 10.125 11.25Z",
    fill: "currentColor"
  })));
};
export { SvgCalendarIcon as ReactComponent };